var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff4A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 74.9 172.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ececec;}.cls-2{fill:#232323;}.cls-3{fill:#916657;}.cls-4{fill:#1199a1;}.cls-5{fill:#0e5279;}.cls-6{fill:#004568;}.cls-7{fill:#14adb2;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Staff_Female_04c",
    "data-name": "Staff_Female_04c",
    viewBox: "0 0 74.9 172.58"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.28 59.4 74.9 42.55 56.72 37.9 38.54 54.3 54.28 59.4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_19",
    "data-name": "New Symbol 19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.58,165s-2,4.72-.57,6.18,3.11,2.52,9.84-.43,12.51-7.76,10.18-9.08-8.17-.75-12.57,1.07A37.07,37.07,0,0,1,29.58,165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.62,151s-.44,4.88-.67,6.43,1.91,4.47,8.43.89c4.43-2.44,7.49-3.74,10.2-5.77s.22-4.43-3.11-4S6.62,151,6.62,151Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.6,32.15l.22-6c-5.32-2.88-11.31-10-7.54-17.51S20.37,1.33,24.14,2.22s9.09,3.32,9.31,8.86,0,12.42-.89,14-5.32,2.22-5.32,2.22c-.22,2-.44,6.21-.44,6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.7,0a13.79,13.79,0,0,0-6.87,2A6.2,6.2,0,1,0,6,12.34a11.4,11.4,0,0,0,0,1.85c.44,6.21,7.31,12.41,10.86,12s6.87-1.77,6.65-3.77c-1.33.22-3-.94-3.32-4.1S23.64,13.22,25,16c0,0,9.76-3.1,8.43-10C30.56,2.66,26.35,0,19.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.83,28.82c-2.84-1.82-6.27.1-8,2.67S1.42,39.5.41,47.23C-.25,52.32-.27,58.3,1.52,60.08s6.21,2.66,10.64.67S15.93,30.82,12.83,28.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M26.79,125.25c.22,10.19,1.11,32.58,1.11,39.23s12.11,3.34,12.42-3.1c.44-9.31.66-39.68.66-39.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.7,122.58c-.89,14.64-2,23.73-2.44,28.16s-12.41,6.21-12.19,0c.3-8.43,2-35,2-35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.09,60.73l8.43-3.1a36.22,36.22,0,0,1,5.54-4.88c2.22-1.33,4-2.22,4.88-1.77s-2.88,3.77-2.88,3.77a74.94,74.94,0,0,1,7.76-2,2.64,2.64,0,0,1,1.1,2.44c-.22,1.55-2.43,4.88-2.43,4.88L56.28,63l-6.21.44L41.42,67.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M19.39,29c5.54,1.66,13.61,2.49,15.38,7.14s3.11,31.71,4,37.47S42.53,88,43.64,99.53s2,23.5,2,23.5c-4.44,4.88-14.86,5.32-20,5.1S9.06,127.24,4,121c.44-8.42,1.11-25,1.77-35S8.29,68.63,6.84,58.52C5.73,50.76,5.29,44.11,6.4,37.68,7.38,32,9.62,26.06,19.39,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.89,33c4.36-.87,7.1,5.76,7.76,13.08s1.11,12,1.11,12,4.88-.22,7.76-.44,5.51,5.71,1.77,8.2C47,68.05,39.43,71.15,36.1,69.6S28.34,56.74,27,49.87,25.24,34.35,31.89,33Z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kontor_Lager",
    "data-name": "Kontor & Lager"
  }, /*#__PURE__*/React.createElement("use", {
    width: 74.9,
    height: 172.58,
    transform: "matrix(-1, 0, 0, 1, 74.9, 0)",
    xlinkHref: "#Staff_Female_04c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff4A);
export default __webpack_public_path__ + "static/media/staff-4-a.7f7fb6c72b43411835ccb57324856f59.svg";
export { ForwardRef as ReactComponent };